(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["sale-bar"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initSaleBar(bar) {
      if (bar.dataset.saleBarReady) return;
      bar.dataset.saleBarReady = 'true';

      var hours = parseFloat(bar.dataset.durationHours) || 2;
      var durationMs = hours * 60 * 60 * 1000;
      var storageKey = bar.dataset.storageKey || 'blockface_sale_timer';
      var units = {
        days: bar.querySelector('[data-unit="days"]'),
        hours: bar.querySelector('[data-unit="hours"]'),
        minutes: bar.querySelector('[data-unit="minutes"]'),
        seconds: bar.querySelector('[data-unit="seconds"]'),
      };

      function readEnd() {
        try {
          return Number(window.localStorage.getItem(storageKey));
        } catch (e) {
          return 0;
        }
      }

      function writeEnd(value) {
        try {
          window.localStorage.setItem(storageKey, String(value));
        } catch (e) {
          /* storage unavailable */
        }
      }

      var endTime = readEnd();
      if (!endTime || endTime <= Date.now()) {
        endTime = Date.now() + durationMs;
        writeEnd(endTime);
      }

      function pad(n) {
        return String(n).padStart(2, '0');
      }

      function tick() {
        var distance = endTime - Date.now();
        if (distance <= 0) {
          endTime = Date.now() + durationMs;
          writeEnd(endTime);
          distance = endTime - Date.now();
        }
        var days = Math.floor(distance / 86400000);
        var hrs = Math.floor((distance % 86400000) / 3600000);
        var mins = Math.floor((distance % 3600000) / 60000);
        var secs = Math.floor((distance % 60000) / 1000);
        if (units.days) units.days.textContent = pad(days);
        if (units.hours) units.hours.textContent = pad(units.days ? hrs : hrs + days * 24);
        if (units.minutes) units.minutes.textContent = pad(mins);
        if (units.seconds) units.seconds.textContent = pad(secs);
      }

      tick();
      setInterval(tick, 1000);
    }

    function initAll() {
      document.querySelectorAll('[data-sale-bar]').forEach(initSaleBar);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll, { once: true });
    } else {
      initAll();
    }
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scroll-to-top"]) return;
  try {
    
  (function () {
    function initScrollToTop() {
      var buttons = document.querySelectorAll('[data-scroll-to-top]');
      if (!buttons.length) return;
      function check() {
        var y = window.scrollY || window.pageYOffset;
        buttons.forEach(function (btn) {
          var after = parseInt(btn.dataset.showAfter) || 400;
          btn.style.display = y > after ? '' : 'none';
        });
      }
      buttons.forEach(function (btn) {
        if (btn.dataset.ready) return;
        btn.dataset.ready = 'true';
        btn.addEventListener('click', function () {
          window.scrollTo({ top: 0, behavior: 'smooth' });
        });
      });
      check();
      window.addEventListener('scroll', check, { passive: true });
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initScrollToTop, { once: true });
    } else {
      initScrollToTop();
    }
    document.addEventListener('shopify:section:load', initScrollToTop);
  })();

  } catch(e) { console.error(e); }
})();
})();
